import PropTypes from 'prop-types';
import { JobCreationContext } from './job-creation-context';

// ----------------------------------------------------------------------

export default function JobCreationConsumer({ children }) {
  return (
    <JobCreationContext.Consumer>
      {jobCreation => children}
    </JobCreationContext.Consumer>
  );
}

JobCreationConsumer.propTypes = {
  children: PropTypes.node,
};
